import moment from "moment"

export function FilterSearch(data, search) {
	return data.filter((item) => {
		const itemValues = Object.values(item).map((value) => {
			return String(value).toLowerCase()
		})
		return itemValues.some((value) => value.includes(search.toLowerCase()))
	})
}

export const SlicePrefix = (data, slice = 4) => {
	return data.slice(slice)
}

export const SortByProperty = (data, keys, type = "1") => {
	let result = []
	switch (type) {
		case "1":
			result = [...data].sort((a, b) => {
				return a[keys] - b[keys]
			})
			break
		case "-1":
			result = [...data].sort((a, b) => {
				return b[keys] - a[keys]
			})
			break
		case "NAME":
			result = [...data].sort((a, b) => {
				return SlicePrefix(a.Name).localeCompare(SlicePrefix(b.Name))
			})
			break
	}
	return result
}

export const CalculateAge = (dateOfBirth) => {
	const now = moment()
	const birthDate = moment(dateOfBirth)
	const yearsDiff = now.diff(birthDate, "years")

	return yearsDiff
}

export const ConvertMonth = (month) => {
	const months = [
		'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.',
		'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.',
		'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
	];

	return months[month - 1] || ''; // Adjust for 0-based index, and handle out-of-range values
};


export const formatDateThai = (dateString) => {
	const months = [
		'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.',
		'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.',
		'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
	];

	if (dateString === 'Invalid date' || dateString === undefined || dateString === 'undefined' || dateString === 'null' || dateString === null) {
		return ''
	} else {


		let [year, month, day] = dateString?.split('-');
		let thaiYear = Number(year) + 543;

		return `${day} ${months[Number(month) - 1]} ${thaiYear}`;
	}



}


export const formatDateThaiFull = (dateString) => {
	const months = [
		'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน',
		'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม',
		'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
	];

	if (dateString === 'Invalid date' || dateString === undefined || dateString === 'undefined' || dateString === 'null' || dateString === null) {
		return ''
	} else {

		const [year, month, day] = dateString?.split('-');
		const thaiYear = Number(year) + 543;

		return `${day} ${months[Number(month) - 1]} ${thaiYear}`;
	}


}





export const calculateAgeYYYYMMDD = (birthdate, str) => {
	const today = moment();
	const birthDate = moment(birthdate, 'YYYY-MM-DD');
	const years = today.diff(birthDate, 'years');

	// คำนวณเดือนและวันเพิ่มเติม
	const months = today.diff(birthDate, 'months') % 12;
	const days = today.diff(birthDate.add(years, 'years').add(months, 'months'), 'days');
	if (str) {
		return `${years} ปี ${months} เดือน ${days} วัน`

	} else {
		return { years, months, days };

	}

}


export const calculateAgeYYYYMMDDV2 = (birthdate) => {

	if (birthdate === 'Invalid date') {

		return ''

	} else {
		const today = moment();
		const birthDate = moment(birthdate, 'YYYY-MM-DD');
		const years = today.diff(birthDate, 'years');

		// คำนวณเดือนและวันเพิ่มเติม
		const months = today.diff(birthDate, 'months') % 12;
		const days = today.diff(birthDate.add(years, 'years').add(months, 'months'), 'days');

		return `${years} ปี ${months} เดือน ${days} วัน `
	}


}



export const TabPanel = (props) => {
	const { children, value, index, style, ...other } = props
	return (
		<div role="tabpanel" hidden={value !== index} style={style} {...other}>
			{value === index && children}
		</div>
	)
}

export const formatDate = (date) => {
	if(date&&date.length>0&&date!='-'){
		const newDate = new Date(date)
		const result = newDate.toLocaleDateString('th-TH', {
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		})
		return result
	}else{

		return ''
	}

}

export const FormatPrice = (data, toFixed = 2) => {
	let _data = data ? Number(String(data).replaceAll(",", "")) : 0
	const formatter = new Intl.NumberFormat("th-TH", {
		maximumFractionDigits: toFixed,
		minimumFractionDigits: toFixed,
	})
	return formatter.format(_data)
}

export const convertDate = (dataDate) => {
	const date = new Date(dataDate)
	const optionDate = {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	}
	const thaiLocale = 'th-TH';
	const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

	const newDate = `${formattedDate}`
	return newDate
}


export const comma=(number)=> {
	return number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}